// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"508":"component---src-templates-panel-js","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"508":"b90a70d22b01bf4b28e3","678":"877e2d19b88d252c23ac","883":"580e0fb6ef3a7fc77090"}[chunkId] + ".js";
};